import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  LeftSidebarView, ViewBody,
} from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import KanBoIcon from 'components/KanBoIcon'
import {
  ListItem
} from 'components/List'
import InfiniteScroll from 'components/InfiniteScroll'
import { useDispatch, useSelector } from 'react-redux'
import { sagaActions as rootSagaActions } from 'store/sagas'
import { documentTemplateSourcesSelector } from 'selectors/documentTemplateSources'
import AddDocumentTemplateSource from './AddDocumentTemplateSource'
import requestRemoveDocumentTemplateSource from 'store/sagas/requestRemoveDocumentTemplateSource'
import DocumentTemplateSourceDetails from 'components/DocumentTemplateSourceDetails'

const DocumentTemplateSources: React.FC<LeftSidebarProps> = ({
  leftSidebar
}) => {
  const dispatch = useDispatch()

  const areDocumentTemplateSourcesLoading = useSelector<any, boolean>(state => state.kanbo.documentTemplateSources.isLoading)
  const areDocumentTemplateSourcesLoaded = useSelector<any, boolean>(state => state.kanbo.documentTemplateSources.isLoaded)
  const documentTemplateSources = useSelector<any, any[]>(documentTemplateSourcesSelector)

  const handleAddDocumentSourceClick = () => {
    leftSidebar.push(AddDocumentTemplateSource)
  }

  const loadDocumentSources = () => {
    dispatch(rootSagaActions.fetchDocumentTemplateSources())
  }

  return (
    <LeftSidebarView
      title={<FormattedMessage id='DOCUMENT_TEMPLATE_SOURCES' />}
      buttons={[{
        icon: <KanBoIcon fixedWidth name='kanbo-16-plus' />,
        title: <FormattedMessage id='ADD' />,
        onClick: handleAddDocumentSourceClick
      }]}
    >
      <InfiniteScroll
        isLoading={areDocumentTemplateSourcesLoading}
        isLoaded={areDocumentTemplateSourcesLoaded}
        onLoadMore={loadDocumentSources}
      >
        <ul className='list-group'>
          {documentTemplateSources.map(source => {
            const onRemoveClick = () => {
              dispatch(requestRemoveDocumentTemplateSource({ id: source.id }))
            }

            return (
              <ListItem
                key={source.id}
                className={
                  typeof source.isReadable !== 'undefined'
                    ? (source.isReadable ? 'list-group-item-success' : 'list-group-item-danger')
                    : null
                }
                icon={
                  !source.isBusy
                    ? <KanBoIcon name='kanbo-16-document-template-source' />
                    : <KanBoIcon spin name='kanbo-16-loading' />
                }
                subtitle={source.url}
                menu={[
                  {
                    icon: <KanBoIcon fixedWidth name='kanbo-16-info' />,
                    title: <FormattedMessage id='DOCUMENT_TEMPLATE_SOURCES_DETAILS' />,
                    onClick: () => {
                      leftSidebar.push(() => 
                        <LeftSidebarView
                          title={source.name}
                        >
                          <ViewBody>
                            <DocumentTemplateSourceDetails
                              id={source.id}
                              url={source.url}
                            />
                          </ViewBody>
                        </LeftSidebarView>
                      )
                    }
                  },
                  {
                    icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
                    title: <FormattedMessage id='REMOVE' />,
                    onClick: onRemoveClick
                  }
                ]}
              >
                {source.name}
              </ListItem>
            )
          })}
        </ul>
      </InfiniteScroll>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(DocumentTemplateSources)
